<mat-card *ngIf="this.codeCa1">
    <mat-card-content>
      <div *ngIf="bcLine">
        <div class="header-class">Enveloppe</div>
        <form focusInvalidInput [formGroup]="bcLine">
          <div class="row">
            <div class="col-md-3">
              <mat-form-field class="full-width">
                <mat-label>Destination</mat-label>
                <mat-select formControlName="destination">
                  <mat-option [value]="destination" *ngFor="let destination of this.referentiel.destinations">{{ getString(destination) }}</mat-option>
                </mat-select>
                <mat-error>Veuillez saisir une destination</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <app-autocomplete-with-code-libelle-form [objets]="this.referentiel.familles" [parent]="bcLine" libelle="Familles" codeControlName="codeFamille" libelleControlName="libelleFamille" placeholder="Famille">
              </app-autocomplete-with-code-libelle-form>
            </div>
            <div class="col-md-3">
              <app-autocomplete-with-code-libelle-form [objets]="this.referentiel.ssFamilles" [parent]="bcLine" libelle="Sous Famille" codeControlName="codeSsFamille" libelleControlName="libelleSsFamille" placeholder="sous Famille">
              </app-autocomplete-with-code-libelle-form>
            </div>
            <div class="col-md-3">
                <app-autocomplete-with-code-libelle-form [objets]="this.referentiel.categories" [parent]="bcLine" libelle="Catégorie" codeControlName="codeCategorie" libelleControlName="libelleCategorie" placeholder="Catégorie">
                </app-autocomplete-with-code-libelle-form>
              </div>
          </div>
          <div class="row">
            <div class="col-md-4">
                <app-autocomplete-with-code-libelle-form [parent]="bcLine" libelle="NA" codeControlName="codeNa" libelleControlName="libelleNa" placeholder="NA" [objets]="this.referentiel.nas">
                </app-autocomplete-with-code-libelle-form>
              </div>
              <div class="col-md-4">
                <app-autocomplete-with-code-libelle-form [parent]="bcLine" libelle="CG Charge" codeControlName="codeCgCharge" libelleControlName="libelleCgCharge" placeholder="CG" [objets]="[]">
                </app-autocomplete-with-code-libelle-form>
              </div>
              <div class="col-md-4">
                <mat-form-field class="full-width">
                  <mat-label>Montant HT</mat-label>
                  <input matInput type="number" placeholder="HT" formControlName="ht" lang="fr">
                  <mat-icon matSuffix style="color: gray !important; font-size: 14px !important;">euro_symbol</mat-icon>
                  <mat-error *ngIf="!bcLine.get('ht').valid">
                    Veuillez saisir un montant positif
                </mat-error>
                </mat-form-field>
              </div>
          </div>
        </form>
      </div>
    </mat-card-content>
  </mat-card>